<style lang="css">
@import '../css/bootstrap.css';
@import '../css/bootstrap-vue.css';
@import '../css/admin-table.css';
</style>
<style lang="scss" scoped>
@import '../css/admin.scss';
</style>
<template>
  <div class="admin-page">
    <admin-header></admin-header>
    <admin-side></admin-side>
    <section class="admin-template">
      <h2 class="sub-tit">답변자게시판 관리</h2>
      <div class="contents">
        <b-container fluid>
          <!-- User Interface controls -->
            <b-row>
             <b-col class="my-1 text-left type-box">
               <b-form-group
                label="답변여부"
                label-for="form-select"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                class="mb-0 "
              >
               <b-form-select size="sm" class="item-select" v-model="itemSelected" :options="itemOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="my-1 text-left half-calendar">
              <div class="date-container">
                <b-form-datepicker
                  id="occurrence-start"
                  class="date-picker"
                  placeholder="시작일"
                  locale="ko-kr"
                  hide-header
                  :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  }"
                  v-model="occurrenceStart"
                >
                </b-form-datepicker>
                <span class="waves">~</span>
                <b-form-datepicker
                  id="occurrence-end"
                  class="date-picker"
                  placeholder="종료일"
                  locale="ko-kr"
                  hide-header
                  :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  }"
                  v-model="occurrenceEnd"
                >
                </b-form-datepicker>
            </div>
            </b-col>
            <b-col class="my-1 filter-box calendar">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    type="search"
                    v-model="searchText"
                    placeholder="질문사항 제목을 입력해 주세요."
                  ></b-form-input>
                  <b-button size="sm" @click="itemFilter()" class="search-btn">검색</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table
            id="expert-management"
            :items="items"
            :fields="fields"
            stacked="md"
            show-empty
            small
          >
            <template #cell(qnaAnswerYn)="row">
              {{ row.value }}
            </template>
            <template #cell(qnaId)="row">
              {{ row.value }}
            </template>
            <template #cell(qnaTitle)="row">
              {{ row.value | truncate(50, '...') }}
            </template>
            <template #cell(qnaQuestionTime)="row">
              {{ row.value }}
            </template>
            <template #cell(actions)="row">
              <b-button size="sm" @click="modifyWrite(row.item, row.index)" class="save-btn mr-1">답변</b-button>
              <b-button size="sm" @click="deleteItem(row.item, row.index)" class="deleat-btn">삭제</b-button>
            </template>
          </b-table>
        </b-container>
      </div>
        <b-modal
          id="modify-write"
          class="item-modal qna"
          size="lg"
          title="질문사항 답변하기"
          @show="resetModal"
          @hidden="resetModal"
          >
            <b-row class="modal-top-row">
              <b-col sm="12" class="my-1 modal-top-area">
                <div class="my-1 text-left modal-top-left" style="width:375px;">
                  <label>질문번호</label>
                  <b-form-input
                    v-model="qnaModal.qnaId"
                    disabled
                  ></b-form-input>
                </div>
                <div class="my-1 text-left modal-top-center" style="width:375px;">
                  <label>유저ID</label>
                  <b-form-input
                  v-model="qnaModal.userId"
                  disabled
                ></b-form-input>
               </div>
              </b-col>
              <b-col sm="12" class="my-1 modal-top-area">
                <div class="my-1 text-left modal-top-left" style="width:750px;">
                  <label>질문제목</label>
                  <b-form-input
                    v-model="qnaModal.qnaTitle"
                    disabled
                  ></b-form-input>
                </div>
              </b-col>
              <b-col class="my-1 text-left type-box footer-command-box" sm="12">
                <b-row class="modal-top-row">
                  <b-col sm="6" class="half text-left"><label>질문 내용</label></b-col>
                  <b-col sm="6" class="half text-right"><label > {{ qnaModal.qnaQuestionTime }} </label></b-col>
                </b-row>
                <div class="qna-description" v-html ="qnaModal.qnaQuestion">
                </div>
              </b-col>
            </b-row>
          <template #modal-footer class="modify-footer-area">
            <b-row>
                <b-col sm="6" class="half text-left" style="padding-left:0;"><label>답변 내용</label></b-col>
                <b-col sm="6" class="half text-right" style="padding-right:0;"><label>{{ qnaModal.qnaAnswerTime }}</label></b-col>
            </b-row>
            <quill-editor
            class="qna"
            ref="modifyWriteEditor"
            v-model="modifyEditorContent"
            :options="modifyEditorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
          />
            <b-col class="my-1 text-right type-box new-command-box" sm="12">
              <div class="right-column">
                <b-button
                variant="primary"
                size="sm"
                @click="modalSave()"
              >
                저장
              </b-button>
              </div>
            </b-col>
          </template>
        </b-modal>
    </section>
  </div>
</template>
<script>
import AdminHeader from '@/components/AdminHeader'
import AdminSide from '@/components/AdminSide'

import { mapGetters } from 'vuex'

export default {
  name: 'AdminQna',
  components: {
    'admin-header': AdminHeader,
    'admin-side': AdminSide
  },
  data () {
    return {
      layerPopPost: false,
      itemSelected: '',
      typeSelected: '0',
      addressCitySelected: '0',
      editorContent: '',
      occurrenceStart: '',
      occurrenceEnd: '',
      searchText: '',
      itemOptions: [
        { value: '', text: '전체' },
        { value: 'Y', text: '답변' },
        { value: 'N', text: '미답변' }
      ],
      /* items: [
        { status: '답변', number: '1', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' },
        { status: '답변', number: '2', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' },
        { status: '답변', number: '3', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' },
        { status: '답변', number: '4', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' },
        { status: '답변', number: '5', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' },
        { status: '답변', number: '6', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' },
        { status: '답변', number: '7', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' }
      ], */
      fields: [
        { key: 'qnaAnswerYn', label: '답변 여부', class: 'text-center' },
        { key: 'qnaId', label: '질문 번호', class: 'text-center' },
        { key: 'qnaTitle', label: '질문 내용', class: 'text-center' },
        { key: 'qnaQuestionTime', label: '질문 등록일', class: 'text-center' },
        { key: 'actions', label: '', class: 'text-center' }
      ],
      qnaModal: {
        qnaAnswer: '',
        qnaAnswerTime: '',
        qnaAnswerYn: '',
        qnaId: '',
        qnaQuestion: '',
        qnaQuestionTime: '',
        qnaTitle: '',
        userId: ''
      },
      modifyEditorContent: '<h2>답변내용 입력</h2>',
      modifyEditorOption: {
        // Some Quill options...
      }
    }
  },
  created () {
    this.dateSetting()
    this.searchQnaAnswer()
  },
  methods: {
    searchQnaAnswer () {
      this.$store.dispatch('apiAnswerList', {'preYmd': this.occurrenceStart, 'nextYmd': this.occurrenceEnd, 'qnaTitle': this.searchText, 'answerYn': this.itemSelected})
    },
    dateSetting () {
      let today = new Date()
      let preDay = new Date()

      let curYear = today.getFullYear()
      let curMonth = today.getMonth() + 1
      let curDate = today.getDate()
      this.occurrenceEnd = curYear + '-' + curMonth + '-' + curDate

      // today = today.getDay() - 7
      preDay.setDate(preDay.getDate() - 30)

      let preYear = preDay.getFullYear()
      let preMonth = preDay.getMonth() + 1
      let preDate = preDay.getDate()

      this.occurrenceStart = preYear + '-' + preMonth + '-' + preDate
    },
    modifyWrite (item, index) {
      this.qnaModal.title = '전문가 답변하기'
      this.$root.$emit('bv::show::modal', 'modify-write')
      this.qnaModal.qnaAnswer = item.qnaAnswer
      this.qnaModal.qnaAnswerTime = item.qnaAnswerTime
      this.qnaModal.qnaAnswerYn = item.qnaAnswerYn
      this.qnaModal.qnaId = item.qnaId
      this.qnaModal.qnaQuestion = item.qnaQuestion
      this.qnaModal.qnaQuestionTime = item.qnaQuestionTime
      this.qnaModal.qnaTitle = item.qnaTitle
      this.qnaModal.userId = item.userId
      if (this.qnaModal.qnaAnswer === null || this.qnaModal.qnaAnswer === '') {
        this.modifyEditorContent = '<h2>답변내용 입력</h2>'
      } else {
        this.modifyEditorContent = this.qnaModal.qnaAnswer
      }
    },
    modalSave () {
      const params = {
        'qnaAnswer': this.modifyEditorContent,
        'qnaId': this.qnaModal.qnaId
      }
      this.saveQnaAnswer('U', params)
    },
    itemFilter () {
      this.searchQnaAnswer()
    },
    deleteItem (item, index) {
      // alert('삭제')
      const deleteConfirm = confirm('정말 삭제하시겠습니까??')
      if (deleteConfirm === true) {
        this.saveQnaAnswer('D', item)
      } else {
        return false
      }
    },
    saveQnaAnswer (type, obj) {
      const params = {
        'qnaAnswer': obj.qnaAnswer,
        'qnaId': obj.qnaId,
        'flag': type
      }
      this.$store.dispatch('apiTranQnaAnswer', params).then(() => {
        // console.log('this.tranQnaAnswer = ' + this.tranQnaAnswer)
        if (this.tranQnaAnswer !== 'fail') {
          if (type === 'U') {
            alert('답변 완료')
            this.$nextTick(() => {
              this.$bvModal.hide('modify-write')
            })
          } else {
            alert('삭제')
          }
          this.searchQnaAnswer()
        } else {
          alert('내용 변경에 실패하였습니다.')
        }
      })
    },
    resetModal () {
      // alert('resetModal')
    },
    onEditorBlur (quill) {
      // console.log('editor blur!', quill)
    },
    onEditorFocus (quill) {
      // console.log('editor focus!', quill)
    },
    onEditorReady (quill) {
      // console.log('editor ready!', quill)
    },
    onEditorChange ({ quill, html, text }) {
      // console.log('editor change!', quill, html, text)
      this.editorContent = html
    }
  },
  mounted () {
    // console.log('this is current quill instance object', this.editor)
  },
  computed: {
    ...mapGetters({
      items: 'getAnswerList',
      tranQnaAnswer: 'getTranAnswerData'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/admin/AdminQna.vue